import { generateResolver, SearchBar, TextHistory } from "dyl-components";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Form, Grid, Segment } from "semantic-ui-react";
import ChatBox from "./ChatBox";
import tcrActions from "actions/tcr"

import './index.scss';
import {  useEffect, useMemo, useState } from "react";
import { FileUtils, PhoneUtil } from "utils";
import { FILE_CATEGORIES } from "utils/FileUtils";
import { Link } from "react-router-dom";
import templateCategoryActions from "actions/template_category"
import FullScreenModalPopUp from "shared/FullScreenModalPopUp";

function TextingComponents({ filteredMessages = [], isReadingFilteredMessages = false, messages = [], messagesCount = 0, loading = false, onPageChange, activePage = 1, onRowClick = () => { }, recipientId, recipientName, isLoadingRecipientDetails, recipientOptions, onFilter, selectedRecipientFilters, selectedSenderFilters, selectedRow, isPanel, userOptions, onReadMessages, onReplaceRecipientVariable, isAccount, contact_phone, customer_phone, onChangeNumbers, recipientFilterOptions, search, selectedTextActivityLog, isArchivedRecord }) {
    const textPhones = useSelector(state => state.text.phones || []);
    const defaultRecipient = recipientOptions.find(option => option.main)?.phone || recipientOptions[0]?.phone || undefined;
    const defaultSender = textPhones.length > 0 ? textPhones[0] : '';
    const methods = useForm({
        defaultValues: {
            message: '',
            attachments: [],
            user: "all",
            include_opt_out: false
        },
        mode: 'onChange',
        resolver: generateResolver({
            attachments: FileUtils.getFilesizeValidator(FILE_CATEGORIES.TEXT)
        })
    });
        const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const selectedUser = methods.watch('user');
    const userFilteredMessages = useMemo(() => {
        if (selectedUser === 'all') return filteredMessages;

        return filteredMessages.filter(msg => msg.user_id === selectedUser || msg.direction === "inbound");
    }, [filteredMessages, selectedUser]);

    const handleRowClick = async (conversation) => {
        if (methods.formState.isDirty) {
            setIsConfirmationOpen(conversation);
        } else {
            await onRowClick(conversation);
            methods.reset();
        }
    }
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(templateCategoryActions.readCategorizedTemplates({ category: 'text' }));
        dispatch(tcrActions.getBrand()).then((data) => {
            dispatch(tcrActions.getBrandOptOutStatus(data?.brandId))
        })
    }, [dispatch])
    
    return (
        <FormProvider {...methods}>
            <Form>
                <Segment color='blue' as={Grid} divided>
                    {isPanel && (
                        <Grid.Row style={{ padding: 0, margin: 0 }}>
                            <Grid.Column style={{ padding: 0, margin: 0 }}>
                                <SearchBar
                                    search={search}
                                    searchFcn={(value) => {
                                        onFilter(null, {
                                            name: 'search',
                                            value
                                        })
                                    }}
                                    cancelFcn={() => {
                                        onFilter(null, {
                                            name: 'search',
                                            value: ''
                                        })
                                    }}
                                    placeholder={'Search by name or number'}
                                    shouldUnformatPhone
                                />
                            </Grid.Column>
                        </Grid.Row>
                    )}
                    <Segment.Group as={Grid.Row} stretched horizontal className={`TextTab ${isPanel ? 'TextTab--panel' : ''} basic`} columns='equal' >
                        <Segment as={Grid.Column} basic className='TextTab__messages'>
                            <Segment.Group className="basic">
                                <TextHistory
                                    messages={messages.map(message => {
                                        const { name, id, contact_type, archived } = message.recipientInfo || { name: message?.contact_name };
                                        return ({
                                            ...message,
                                            contact_name: name || message.contact_name,
                                            link: name && !archived && <Link to={`/${contact_type === 'person' ? 'contact' : contact_type}/${id}`} target="_blank">{name}</Link>,
                                            is_read: message.read
                                        });
                                    })}
                                    messagesCount={messagesCount}
                                    isTableEmpty={messages.length === 0}
                                    onPageChange={onPageChange}
                                    activePage={activePage}
                                    loading={loading}
                                    recipientOptions={recipientFilterOptions?.map((phone) => ({
                                        key: phone.phone,
                                        value: phone.phone,
                                        text: PhoneUtil.formatPhoneNumber(phone.phone)
                                    }))}
                                    senderOptions={textPhones?.map((phone) => ({
                                        key: phone,
                                        value: phone,
                                        text: PhoneUtil.formatPhoneNumber(phone)
                                    }))}
                                    selectedSenders={selectedSenderFilters}
                                    onFilter={onFilter}
                                    selectedRecipients={selectedRecipientFilters}
                                    onRowClick={handleRowClick}
                                    selectedRow={selectedRow}
                                />
                            </Segment.Group>
                        </Segment>
                        <Segment as={Grid.Column} basic className='TextTab__chatbox'>
                            {(!isPanel || (isPanel && contact_phone && customer_phone)) && (
                                <ChatBox 
                                    onReadMessages={onReadMessages} 
                                    userOptions={userOptions} 
                                    recipientOptions={recipientOptions} 
                                    messages={selectedUser !== "all" ? userFilteredMessages : filteredMessages} 
                                    isReadingMessages={isReadingFilteredMessages} 
                                    recipientId={recipientId} 
                                    recipientName={recipientName} 
                                    isLoadingRecipientDetails={isLoadingRecipientDetails} 
                                    onReplaceRecipientVariable={onReplaceRecipientVariable}
                                    isAccount={isAccount}
                                    to={contact_phone || defaultRecipient}
                                    from={customer_phone || defaultSender}
                                    onChangeNumbers={onChangeNumbers}
                                    selectedTextActivityLog={selectedTextActivityLog}
                                    isArchivedRecord={isArchivedRecord}
                                />
                            )}
                        </Segment>
                    </Segment.Group>
                </Segment>
            </Form>
            <FullScreenModalPopUp
                header={"Text will not be saved."}
                subheader={"Are you sure you want to exit?"}
                isOpen={isConfirmationOpen}
                onConfirm={async () => {
                    await onRowClick(isConfirmationOpen);
                    methods.reset();
                    setIsConfirmationOpen(false);
                }}
                onFormClose={() => setIsConfirmationOpen(false)}
                closeIcon={false}
            />
        </FormProvider>
    )
}

export default TextingComponents;
